module.exports = __webpack_public_path__ + "img/pns_tip_ico.427babb0.png";